document.addEventListener("DOMContentLoaded", () => {
  // 短暂延迟关闭，避免移入下拉内容时瞬间 mouseleave 造成抖动
  const CLOSE_DELAY_MS = 120;
  $(".mega-menu").each(function () {
    const $menu = $(this);
    let closeTimer = null;

    $menu.on("mouseenter", function () {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
      $menu.attr("open", "open");
    });

    $menu.on("mouseleave", function () {
      closeTimer = setTimeout(() => {
        $menu.removeAttr("open");
        closeTimer = null;
      }, CLOSE_DELAY_MS);
    });
  });

  $(document).on("click", ".mega-menu__nav-link", function (event) {
    const url = $(this).data("url");
    if (!url) return;
    event.preventDefault();
    event.stopPropagation();
    window.location.href = url;
  });

  // M端导航
  $('.menu-pull-down').click(function() {
    var arrow = $(this).find('svg')

    if(arrow.hasClass('arrow-rotation')) {
      arrow.removeClass('arrow-rotation')
    } else {
      arrow.addClass('arrow-rotation')
    }

    $(this).siblings('.mb-secondary-menu').fadeToggle()
  })

  $('.close-mb-menu-btn').click(function() {
    $('.menu-drawer-container').removeClass('menu-opening')
    $('.menu-drawer-container').removeAttr('open')
    $('.menu-drawer-container .header__icon--menu').attr('aria-expanded', 'false')
    // $('body').removeClass('overflow-hidden-tablet')
  })

  initCountrySelector();
});

function normalizeHostname(hostname) {
  return (hostname || '').replace(/^www\./i, '').toLowerCase();
}

function isSameSiteUrl(url) {
  if (!url) return true;
  try {
    const target = new URL(url, window.location.origin);
    return normalizeHostname(target.hostname) === normalizeHostname(window.location.hostname);
  } catch (error) {
    return false;
  }
}

function initCountrySelector() {
  const roots = document.querySelectorAll('[data-country-selector-root]');
  if (!roots.length) return;

  roots.forEach((root) => {
    const popupModal = root.closest('popup-add-modal');
    const dropdown = root.querySelector('[data-country-selector-dropdown]');
    const trigger = root.querySelector('[data-country-selector-trigger]');
    const list = root.querySelector('[data-country-selector-list]');
    const continueBtn = root.querySelector('[data-country-selector-continue]');
    const currentLabel = root.querySelector('[data-country-selector-current-label]');
    const currentIcon = root.querySelector('[data-country-selector-current-icon]');
    const options = root.querySelectorAll('[data-country-selector-option]');

    const closeDropdown = () => {
      if (!dropdown || !trigger || !list) return;
      dropdown.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      list.setAttribute('hidden', '');
    };

    const closeModal = () => {
      closeDropdown();
      if (popupModal && typeof popupModal.hide === 'function') {
        popupModal.hide();
      }
    };

    const selectOption = (option) => {
      options.forEach((item) => {
        const selected = item === option;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-selected', selected ? 'true' : 'false');
      });

      if (currentLabel) currentLabel.textContent = option.getAttribute('data-label') || '';
      if (currentIcon) {
        const iconSource = option.querySelector('.country-selector-dropdown__option-icon');
        if (iconSource) {
          currentIcon.className = iconSource.className;
          currentIcon.setAttribute('data-country-selector-current-icon', '');
          currentIcon.innerHTML = iconSource.innerHTML;
        }
      }
      if (continueBtn) continueBtn.dataset.url = option.getAttribute('data-url') || '';
      closeDropdown();
    };

    if (popupModal) {
      popupModal.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        if (dropdown && dropdown.classList.contains('is-open')) {
          event.stopImmediatePropagation();
          closeDropdown();
        }
      }, true);
    }

    if (trigger && list && dropdown) {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const isOpen = dropdown.classList.contains('is-open');
        if (isOpen) {
          closeDropdown();
        } else {
          dropdown.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          list.removeAttribute('hidden');
        }
      });
    }

    options.forEach((option) => {
      option.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        selectOption(option);
      });
    });

    if (continueBtn) {
      continueBtn.addEventListener('click', (event) => {
        event.preventDefault();
        const url = continueBtn.dataset.url;
        if (!url || isSameSiteUrl(url)) {
          closeModal();
          return;
        }
        window.location.href = url;
      });
    }

    document.addEventListener('click', (event) => {
      if (!popupModal || !popupModal.hasAttribute('open')) return;
      if (dropdown && dropdown.classList.contains('is-open') && !dropdown.contains(event.target)) {
        closeDropdown();
      }
    });
  });
}
